import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import NavigationBar from "../layout/NavigationBar";
import Footer from "../layout/footer";
import "datatables.net-dt/css/jquery.dataTables.css";
import $ from "jquery";
import "datatables.net";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";

function UserList() {
  const navigate = useNavigate();
  const tableRef = useRef(null); // Use ref instead of state for table instance
  const [userId, setUserId] = useState(null);
  const [mobile, setMobile] = useState(null);
  const [rewardPoints, setRewardPoints] = useState("");
  const [isButtonEnabled, setIsButtonEnabled] = useState(false);
  const [showModal, setShowModal] = useState(true);
  const [isButtonEnabledAdd, setIsButtonEnabledAdd] = useState(false);
  const [isButtonEnabledSubtract, setIsButtonEnabledSubtract] = useState(false);
  const [rewardPointsAdd, setRewardPointsAdd] = useState("");
  const [rewardPointsSubtract, setRewardPointsSubtract] = useState("");
  const [rewardPointsAddError, setRewardPointsAddError] = useState(false);

  const [showUserDetailModal, setShowUserDetailModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [userDetails, setUserDetails] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showRewardForm, setShowRewardForm] = useState(false);
  const [selectedLevelReward, setSelectedLevelReward] = useState(null);
  const [rewardFormData, setRewardFormData] = useState({
    reward_amount: '',
    transaction_id: '',
    notes: ''
  });

  const [showSendRewardModal, setShowSendRewardModal] = useState(false);
  const [selectedLevelForReward, setSelectedLevelForReward] = useState(null);
  const [sendRewardFormData, setSendRewardFormData] = useState({
    reward_amount: '',
    transaction_id: '',
    notes: ''
  });

  const [rewardPointsSubtractError, setRewardPointsSubtractError] = useState(false);

  useEffect(() => {
    setIsButtonEnabledAdd(rewardPointsAdd > 0);
    setIsButtonEnabledSubtract(
      rewardPointsSubtract > 0 && rewardPointsSubtract <= rewardPoints
    );
  }, [rewardPointsAdd, rewardPointsSubtract, rewardPoints]);

  const handleChange = (e, actionType) => {
    const value = e.target.value;

    if (actionType === "add") {
      setRewardPointsAdd(value);
      setIsButtonEnabledAdd(value > 0);
    } else if (actionType === "subtract") {
      const valueNumber = Number(value);
      if (valueNumber <= rewardPoints) {
        setRewardPointsSubtract(value);
        setIsButtonEnabledSubtract(valueNumber > 0);
      } else {
        setRewardPointsSubtract("");
        setIsButtonEnabledSubtract(false);
      }
    }
  };

  // Function to fetch data with pagination
  const fetchData = async (
    page,
    search = "",
    length = "",
    orderColumn = "",
    orderDir = ""
  ) => {
    try {
      const limit = length || 10;
      const response = await axios({
        method: "POST",
        url: process.env.REACT_APP_APIURL,
        headers: {
          "Content-Type": "application/json",
        },
        data: JSON.stringify({
          environment: "live",
          apikey: process.env.REACT_APP_APIKEY,
          secret: process.env.REACT_APP_SECRET,
          method: "userList",
          module: "user",
          index: page,
          limit: limit,
          search: search,
          orderColumn: orderColumn,
          orderDir: orderDir,
        }),
      });

      const data = response.data;
      if (data.statusCode === 200) {
        const users = data.result.users;
        const totalUsers = data.result.pagination.totalUsers;

        return {
          draw: data.draw,
          recordsTotal: totalUsers,
          recordsFiltered: totalUsers,
          data: users,
        };
      } else {
        console.error("Failed to fetch users:", data);
        return {
          draw: 0,
          recordsTotal: 0,
          recordsFiltered: 0,
          data: [],
        };
      }
    } catch (error) {
      console.error("Error fetching user data:", error);
      return {
        draw: 0,
        recordsTotal: 0,
        recordsFiltered: 0,
        data: [],
      };
    }
  };

  // Initialize DataTable
  useEffect(() => {
    // Wait for DOM to be ready
    const initializeTable = () => {
      const tableElement = $("#users");

      // Check if table element exists and is visible
      if (tableElement.length === 0) {
        console.error("Table element not found");
        return;
      }

      // Destroy existing DataTable if it exists
      if (tableRef.current) {
        try {
          tableRef.current.destroy();
          tableRef.current = null;
        } catch (error) {
          console.warn("Error destroying existing table:", error);
        }
      }

      // Remove any existing event handlers
      tableElement.off('click.userTable');

      try {
        const table = tableElement.DataTable({
          serverSide: true,
          processing: true,
          ordering: true,
          order: [[7, "desc"]],
          destroy: true, // Allow reinitialization
          ajax: function (data, callback, settings) {
            const page = Math.floor(settings._iDisplayStart / settings._iDisplayLength) + 1;
            const search = data.search.value || "";
            const length = data.length || "";

            let orderColumn = "lastActivityAt";
            let orderDir = "desc";

            try {
              if (
                data.order &&
                data.order[0] &&
                settings.aoColumns &&
                settings.aoColumns[data.order[0].column]
              ) {
                const column = settings.aoColumns[data.order[0].column];
                if (column.name) {
                  orderColumn = column.name;
                  orderDir = data.order[0].dir;
                }
              }
            } catch (error) {
              console.log("Sorting error handled:", error);
            }

            fetchData(page, search, length, orderColumn, orderDir).then(
              (response) => {
                callback({
                  draw: response.draw,
                  recordsTotal: response.recordsTotal,
                  recordsFiltered: response.recordsFiltered,
                  data: response.data,
                });
              }
            );
          },
          columns: [
            {
              data: null,
              orderable: false,
              render: (data, type, row, meta) => meta.row + 1,
            },
            {
              data: "mobile",
              name: "mobile",
              orderable: true,
              render: (data, type, row) => {
                const countryCode = row?.countryCode ? `${row.countryCode}` : "N/A";
                const mobile = data || "N/A";
                return `${countryCode} ${mobile}`;
              },
            },
            {
              data: "deviceType",
              name: "deviceType",
              orderable: true,
              render: (data) =>
                data ? data.charAt(0).toUpperCase() + data.slice(1) : "N/A",
            },
            {
              data: "createdAt",
              name: "createdAt",
              orderable: true,
              render: (data) => new Date(data).toLocaleString() || "N/A",
            },
            {
              data: "latitude",
              name: "latitude",
              orderable: true,
              render: (data, type, row) => {
                if (row.latitude && row.longitude) {
                  const latitude = row.latitude;
                  const longitude = row.longitude;
                  return `<a href="https://www.google.com/maps?q=${latitude},${longitude}" target="_blank">${Number(
                    latitude
                  ).toFixed(4)}, ${Number(longitude).toFixed(4)}</a>`;
                } else {
                  return "N/A";
                }
              },
            },
            {
              data: "lastloginAt",
              name: "lastLoginAt",
              orderable: true,
              render: (data) => new Date(data).toLocaleString() || "N/A",
            },
            {
              data: "location",
              name: "location",
              orderable: true,
              render: (data, type, row) => {
                if (data && Array.isArray(data.coordinates)) {
                  const latitude = data.coordinates[1];
                  const longitude = data.coordinates[0];
                  return `<a href="https://www.google.com/maps?q=${latitude},${longitude}" target="_blank">${Number(
                    latitude
                  ).toFixed(4)}, ${Number(longitude).toFixed(4)}</a>`;
                } else {
                  return "N/A";
                }
              },
            },
            {
              data: "lastActivityAt",
              name: "lastActivityAt",
              orderable: true,
              render: (data) => new Date(data).toLocaleString() || "N/A",
            },
            {
              data: "lastLocationHistory",
              name: "lastLocationHistory",
              orderable: true,
              render: (data, type, row) => {
                if (data && Array.isArray(data.coordinates)) {
                  const latitude1 = data.coordinates[1];
                  const longitude1 = data.coordinates[0];
                  return `<a href="https://www.google.com/maps?q=${latitude1},${longitude1}" target="_blank">${Number(
                    latitude1
                  ).toFixed(4)}, ${Number(longitude1).toFixed(4)}</a>`;
                } else {
                  return "N/A";
                }
              },
            },
            {
              data: null,
              name: "createdGeotagsCount",
              orderable: true,
              render: (data) => {
                const userId = data?._id;
                if (userId && (data.createdGeotagsCount || 0) > 0) {
                  return `
                    <div align="center">
                      <a href="/usergeotags?id=${userId}&type=created" class="count-link" target="_blank">
                        ${data.createdGeotagsCount || 0}
                      </a>
                    </div>
                  `;
                } else {
                  return `
                  <div align="center">
                    ${data.createdGeotagsCount || 0}
                  </div>
                `;
                }
              },
            },
            {
              data: null,
              name: "huntedGeotagsCount",
              orderable: true,
              render: (data) => {
                const userId = data?._id;
                if (userId && (data.huntedGeotagsCount || 0) > 0) {
                  return `
                    <div align="center">
                      <a href="/usergeotags?id=${userId}&type=hunted" class="count-link" target="_blank">
                         ${data.huntedGeotagsCount || 0}
                      </a>
                    </div>
                  `;
                } else {
                  return `
                  <div align="center">
                    ${data.huntedGeotagsCount || 0}
                  </div>
                `;
                }
              },
            },
            {
              data: null,
              name: "openedGeotagsCount",
              orderable: true,
              render: (data) => {
                const userId = data?._id;
                if (userId && (data.openedGeotagsCount || 0) > 0) {
                  return `
                    <div align="center">
                      <a href="/usergeotags?id=${userId}&type=opened" class="count-link" target="_blank">
                         ${data.openedGeotagsCount || 0}
                      </a>
                    </div>
                  `;
                } else {
                  return `
                  <div align="center">
                    ${data.openedGeotagsCount || 0}
                  </div>
                `;
                }
              },
            },
            {
              data: null,
              name: "savedGeotagsCount",
              orderable: true,
              render: (data) => {
                const userId = data?._id;
                if (userId) {
                  return `
                    <div align="center">
                      <a href="/usergeotags?id=${userId}&type=saved" class="count-link" target="_blank">
                        ${data.savedGeotagsCount || 0}
                      </a>
                    </div>
                  `;
                } else {
                  return `
                  <div align="center">
                    ${data.savedGeotagsCount || 0}
                  </div>
                `;
                }
              },
            },
            {
              data: null,
              name: "businessCount",
              orderable: true,
              render: (data) => {
                const userId = data?._id;
                if (userId && (data.businessCount || 0) > 0) {
                  return `
                    <div align="center">
                      <a href="/businesses?id=${userId}" class="count-link" target="_blank">${data.businessCount || 0}
                      </a>
                    </div>
                  `;
                } else {
                  return `
                  <div align="center">
                    ${data.businessCount || 0}
                  </div>
                `;
                }
              },
            },
            {
              data: null,
              name: "contactsCount",
              orderable: true,
              render: (data) => {
                const userId = data?._id;
                if (userId && (data.contactsCount || 0) > 0) {
                  return `
                    <div align="center">
                      <a href="/contacts?id=${userId}&type=contact" class="count-link" target="_blank">${data.contactsCount || 0}
                      </a>
                    </div>
                  `;
                } else {
                  return `
                  <div align="center">
                    ${data.contactsCount || 0}
                  </div>
                `;
                }
              },
            },
            {
              data: null,
              name: "rewardPoints",
              orderable: false,
              render: (data) => {
                const rewardPoints = data.rewardPoints > 0 ? data.rewardPoints : 0;
                const userId = data?._id;
                const mobile = data?.countryCode + data?.mobile;

                if (userId && rewardPoints > 0) {
                  return `
                    <div align="center">
                      <a href="/credits?id=${userId}" class="count-link" target="_blank">
              ${rewardPoints} 
              </a>
            
              <i
              class="fa-solid fa-plus-minus mr-2 add-btn" data-id="${userId}" data-name="${mobile}" data-rewardpoints="${rewardPoints}"
              data-toggle="modal"
              data-target="#addRewardModal"
              style="margin-left: 10px; cursor: pointer;" 
            ></i>
                    </div>
                  `;
                } else {
                  return `
                    <div align="center">
                      ${rewardPoints}
                    </div>
                  `;
                }
              },
            },
            {
              data: null,
              name: "Referrals",
              orderable: true,
              render: (data) => {
                const userId = data?._id;
                if (userId && data.Referrals > 0) {
                  return `
                    <div align="center">
                      <a href="/referrals?id=${userId}&type=refer" class="count-link" target="_blank">
                        ${data.Referrals || 0}
                      </a>
                    </div>
                  `;
                } else {
                  return `
                  <div align="center">
                    ${data.Referrals || 0}
                  </div>
                `;
                }
              },
            },
            {
              data: null,
              name: "referedByUser",
              orderable: true,
              render: (data, type, row) => {
                try {
                  const userId = data?._id;
                  if (row.campaignInfo) {
                    const campaign = JSON.parse(row.campaignInfo);
                    if (campaign?.campaign) {
                      return `<div align="">
                      <a href="/campaign?id=${userId}" class="count-link" target="_blank">
                        Ads
                      </a>
                    </div>`;
                    }
                  }
                  return row.referedByUser || "Direct";
                } catch (e) {
                  return row.referedByUser || "Direct";
                }
              }
            },
            {
              data: null,
              orderable: false,
              render: (data) => {
                const userId = data?._id;
                const mobile = data?.countryCode + data?.mobile;

                if (userId) {
                  return `
                    <div align="center">
                      <i class="fa-solid fa-eye view-details-btn" 
                         data-id="${userId}" 
                         data-name="${mobile}"
                         style="cursor: pointer; margin-right: 10px;" 
                         title="View Details"></i>
                      <i class="fa-solid fa-trash-can delete-btn" 
                         data-id="${userId}" 
                         data-name="${mobile}"
                         data-toggle="modal"
                         data-target="#modaldelete"
                         style="cursor: pointer;" 
                         title="Delete User"></i>
                    </div>
                  `;
                }
                return '<div align="center">-</div>';
              },
            }
          ],
          pageLength: 10,
          lengthMenu: [10, 25, 50, 75, 100],
          responsive: true,
          searching: true,
          paging: true,
          drawCallback: function (settings) {
            if (settings._iDisplayStart === 0 && !this.api().order().length) {
              this.api().order([7, "desc"]).draw();
            }
          },
        });

        // Store table reference
        tableRef.current = table;

        // Add event handlers with namespaced events
        tableElement.on("click.userTable", ".add-btn", function (e) {
          e.preventDefault();
          const userId = $(this).data("id");
          const mobile = $(this).data("name");
          const rewardPoints = $(this).data("rewardpoints");
          setMobile(mobile);
          setUserId(userId);
          setRewardPoints(rewardPoints);
        });

        tableElement.on("click.userTable", ".view-details-btn", function (e) {
          e.preventDefault();
          const userId = $(this).data("id");
          const mobile = $(this).data("name");
          handleViewUserDetails(userId, mobile);
        });

        tableElement.on("click.userTable", ".delete-btn", function (e) {
          e.preventDefault();
          const userId = $(this).data("id");
          const mobile = $(this).data("name");
          setUserId(userId);
          setMobile(mobile);
        });

      } catch (error) {
        console.error("Error initializing DataTable:", error);
      }
    };

    // Use setTimeout to ensure DOM is ready
    const timer = setTimeout(() => {
      initializeTable();
    }, 100);

    // Cleanup function
    return () => {
      clearTimeout(timer);

      // Clean up event handlers
      $("#users").off('click.userTable');

      // Destroy DataTable
      if (tableRef.current) {
        try {
          tableRef.current.clear();
          tableRef.current.destroy();
          tableRef.current = null;
        } catch (error) {
          console.warn("Error cleaning up DataTable:", error);
        }
      }
    };
  }, []); // Empty dependency array - only run once

  const handleSubmit = (actionType) => {
    if (actionType === "add" && rewardPointsAdd > 0) {
      setRewardPointsAddError(false);
      handleAddRewardPoints(userId, rewardPointsAdd, actionType);
    } else if (actionType === "subtract" && rewardPointsSubtract > 0) {
      setRewardPointsSubtractError(false);
      handleAddRewardPoints(userId, rewardPointsSubtract, actionType);
    }
  };

  const handleAddRewardPoints = async (userId, points, actionType) => {
    if (!points || points <= 0) {
      if (actionType === "add") {
        setRewardPointsAddError(true);
      } else {
        setRewardPointsSubtractError(true);
      }
      return;
    }

    try {
      const response = await axios({
        method: "POST",
        url: process.env.REACT_APP_APIURL,
        headers: {
          "Content-Type": "application/json",
        },
        data: JSON.stringify({
          environment: "live",
          userId: userId,
          rewardPoints: points,
          type: actionType,
          apikey: process.env.REACT_APP_APIKEY,
          secret: process.env.REACT_APP_SECRET,
          method: "userRewardsAdd",
          module: "user",
        }),
      });

      const data = response.data;
      console.log(response);

      setRewardPointsAdd("");
      setRewardPointsSubtract("");

      if (data) {
        toast.success(
          `${actionType === "add" ? "Credits added" : "Credits subtracted"
          } successfully!`
        );
        setIsButtonEnabledAdd(false);
        setIsButtonEnabledSubtract(false);

        // Refresh the table
        if (tableRef.current) {
          tableRef.current.ajax.reload(null, false);
        }
      } else {
        toast.error("Error processing reward points.");
      }
    } catch (error) {
      console.error("Error adding reward points:", error);
      toast.error("An error occurred while processing the request.");
    }
  };

  const userDelete = async (userId) => {
    try {
      const response = await axios({
        method: "POST",
        url: process.env.REACT_APP_APIURL,
        headers: {
          "Content-Type": "application/json",
        },
        data: JSON.stringify({
          environment: "live",
          userId: userId,
          apikey: process.env.REACT_APP_APIKEY,
          secret: process.env.REACT_APP_SECRET,
          method: "userDelete",
          module: "user",
        }),
      });

      const data = response.data;
      console.log(response);
      if (data) {
        toast.success("User deleted successfully!");

        // Refresh the table
        if (tableRef.current) {
          tableRef.current.ajax.reload(null, false);
        }
      } else {
        toast.error("Error deleting user.");
      }
    } catch (error) {
      console.error("Error deleting user:", error);
      toast.error("An error occurred while processing the request.");
    }
  };

  const fetchUserDetails = async (userId) => {
    setLoading(true);
    try {
      const response = await axios({
        method: "POST",
        url: process.env.REACT_APP_APIURL,
        headers: {
          "Content-Type": "application/json",
        },
        data: JSON.stringify({
          environment: "live",
          apikey: process.env.REACT_APP_APIKEY,
          secret: process.env.REACT_APP_SECRET,
          method: "getUserDetailedInfo",
          module: "user",
          userId: userId
        }),
      });

      if (response.data.statusCode === 200) {
        setUserDetails(response.data.result);
      } else {
        toast.error("Failed to fetch user details");
      }
    } catch (error) {
      console.error("Error fetching user details:", error);
      toast.error("An error occurred while fetching user details");
    } finally {
      setLoading(false);
    }
  };

  const handleViewUserDetails = (userId, mobile) => {
    setSelectedUser({ userId, mobile });
    setShowUserDetailModal(true);
    fetchUserDetails(userId);
  };

  const handleRewardFormSubmit = async (e) => {
    e.preventDefault();

    if (!rewardFormData.reward_amount || !rewardFormData.transaction_id) {
      toast.error("Please fill in required fields");
      return;
    }

    try {
      const response = await axios({
        method: "POST",
        url: process.env.REACT_APP_APIURL,
        headers: {
          "Content-Type": "application/json",
        },
        data: JSON.stringify({
          environment: "live",
          apikey: process.env.REACT_APP_APIKEY,
          secret: process.env.REACT_APP_SECRET,
          method: "updateLevelReward",
          module: "user",
          userId: selectedUser.userId,
          levelId: selectedLevelReward.levelId,
          reward_amount: parseFloat(rewardFormData.reward_amount),
          transaction_id: rewardFormData.transaction_id,
          notes: rewardFormData.notes
        }),
      });

      if (response.data.statusCode === 200) {
        toast.success("Reward updated successfully!");
        setShowRewardForm(false);
        setRewardFormData({ reward_amount: '', transaction_id: '', notes: '' });
        fetchUserDetails(selectedUser.userId);
      } else {
        toast.error("Failed to update reward");
      }
    } catch (error) {
      console.error("Error updating reward:", error);
      toast.error("An error occurred while updating reward");
    }
  };

  const isTreasureActive = (expiredAt) => {
    if (!expiredAt) return true;
    return new Date(expiredAt) > new Date();
  };

  const formatDate = (date) => {
    return new Date(date).toLocaleString();
  };
  const handleSendLevelReward = async (e) => {
    e.preventDefault();

    if (!sendRewardFormData.reward_amount || !sendRewardFormData.transaction_id) {
      toast.error("Please fill in required fields");
      return;
    }

    try {
      const response = await axios({
        method: "POST",
        url: process.env.REACT_APP_APIURL,
        headers: {
          "Content-Type": "application/json",
        },
        data: JSON.stringify({
          environment: "live",
          apikey: process.env.REACT_APP_APIKEY,
          secret: process.env.REACT_APP_SECRET,
          method: "sendLevelReward",
          module: "user",
          userId: selectedUser.userId,
          levelId: selectedLevelForReward._id,
          reward_amount: parseFloat(sendRewardFormData.reward_amount),
          reward_status: "sent",
          transaction_id: sendRewardFormData.transaction_id,
          notes: sendRewardFormData.notes,
          reward_sent_at: new Date().toISOString()
        }),
      });

      if (response.data.statusCode === 200) {
        toast.success("Level reward sent successfully!");
        setShowSendRewardModal(false);
        setSendRewardFormData({ reward_amount: '', transaction_id: '', notes: '' });
        fetchUserDetails(selectedUser.userId);
      } else {
        toast.error("Failed to send level reward");
      }
    } catch (error) {
      console.error("Error sending level reward:", error);
      toast.error("An error occurred while sending reward");
    }
  };
  return (
    <div className="wrapper">
      <header>
        <NavigationBar />
      </header>

      <div className="content-wrapper">
        <div className="content-header">
          <div className="container-fluid">
            <div className="row mb-2">
              <div className="col-sm-6">
                <h1 className="m-0 txt_lft">Users</h1>
              </div>
            </div>
          </div>
        </div>

        <div className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-lg-12">
                <div className="table-responsive">
                  <table
                    id="users"
                    className="table table-striped table-bordered txt_lft"
                    style={{ width: "100%" }}
                  >
                    <thead>
                      <tr>
                        <th>S.No</th>
                        <th>Phone</th>
                        <th>Device Type</th>
                        <th>CreatedAt</th>
                        <th>Created Location</th>
                        <th>Last Login</th>
                        <th>Last Login Location</th>
                        <th>Last Activity</th>
                        <th>Last Activity Location</th>
                        <th>Dropped</th>
                        <th>Hunted</th>
                        <th>Opened</th>
                        <th>Saved</th>
                        <th>Businesses</th>
                        <th>Contacts</th>
                        <th>GeoCredits</th>
                        <th>Referrals by link</th>
                        <th>Referred by User</th>
                        <th>Action</th>
                        {/* <th>Referrals by GeoTags</th> */}
                      </tr>
                    </thead>
                    <tbody>
                      {/* Data rows will be populated dynamically via DataTable */}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer />
      <Footer />
      {/* Reward Add/Subtract */}
      <div
        className="modal fade"
        id="addRewardModal"
        tabIndex={-1}
        aria-labelledby="addRewardModalLabel"
        aria-hidden="true"
        data-backdrop="static"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="addRewardModalLabel">
                Manage Credits - ({mobile})
              </h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <i className="fa-solid fa-xmark" />
              </button>
            </div>
            <div className="modal-body">
              <div className="w-100 d-inline-block text-center">
                {/* Add Credits Section */}
                <div className="mb-3">
                  <label htmlFor="rewardPointsAdd" className="form-label">
                    Add Credit Points
                  </label>
                  <input
                    type="number"
                    id="rewardPointsAdd"
                    className="form-control"
                    placeholder="e.g., 100, 200"
                    value={rewardPointsAdd}
                    onChange={(e) => handleChange(e, "add")}
                    required
                  />
                  <div
                    id="rewardPointsAddError"
                    className="text-danger mt-2"
                    style={{ display: rewardPointsAddError ? "block" : "none" }}
                  >
                    Please enter valid credit points to add.
                  </div>
                  <div className="mt-3">
                    <button
                      className="btn btn-primary"
                      disabled={!isButtonEnabledAdd}
                      onClick={() => handleSubmit("add")}
                    >
                      Add Credits
                    </button>
                  </div>
                </div>

                {/* Subtract Credits Section */}
                <div className="mb-3">
                  <label htmlFor="rewardPointsSubtract" className="form-label">
                    Subtract Credit Points
                  </label>
                  <input
                    type="number"
                    id="rewardPointsSubtract"
                    className="form-control"
                    placeholder="e.g., 100, 200"
                    value={rewardPointsSubtract}
                    onChange={(e) => handleChange(e, "subtract")}
                    required
                  />
                  <div
                    id="rewardPointsSubtractError"
                    className="text-danger mt-2"
                    style={{
                      display: rewardPointsSubtractError ? "block" : "none",
                    }}
                  >
                    Please enter valid credit points to subtract (must not
                    exceed available points).
                  </div>
                  <div className="mt-3 mb-5">
                    <button
                      className="btn btn-primary"
                      disabled={!isButtonEnabledSubtract}
                      onClick={() => handleSubmit("subtract")}
                    >
                      Subtract Credits
                    </button>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
      {/* Delete Confirmation Modal */}
      <div
        className="modal fade"
        id="modaldelete"
        tabIndex={-1}
        aria-labelledby="modaldeleteLabel"
        aria-hidden="true"
        data-backdrop="static"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="modaldeleteLabel">
                Delete User
              </h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <i className="fa-solid fa-xmark" />
              </button>
            </div>
            <div className="modal-body">
              <div className="w-100 d-inline-block text-center">
                Are you sure you want to delete <br />
                <span className="fwt_600">{mobile}</span>?
              </div>
            </div>
            <div className="modal-footer justify-content-center">
              <button
                type="button"
                className="btn btn-primary"
                data-dismiss="modal"
                aria-label="Close"
                onClick={() => userDelete(userId)}
              >
                Yes, delete
              </button>
              <button
                type="button"
                className="btn btn-secondary"
                data-dismiss="modal"
                aria-label="Close"
              >
                No, cancel
              </button>
            </div>
          </div>
        </div>
      </div>
      <div
        className={`modal fade ${showUserDetailModal ? 'show' : ''}`}
        id="userDetailModal"
        tabIndex={-1}
        aria-labelledby="userDetailModalLabel"
        aria-hidden={!showUserDetailModal}
        style={{ display: showUserDetailModal ? 'block' : 'none' }}
        data-backdrop="static"
      >
        <div className="modal-dialog modal-xl">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="userDetailModalLabel">
                User Details - {selectedUser?.mobile}
              </h5>
              <button
                type="button"
                className="close"
                onClick={() => {
                  setShowUserDetailModal(false);
                  setUserDetails(null);
                }}
                aria-label="Close"
              >
                <i className="fa-solid fa-xmark" />
              </button>
            </div>
            <div className="modal-body" style={{ maxHeight: '70vh', overflowY: 'auto' }}>
              {loading ? (
                <div className="text-center">
                  <div className="spinner-border" role="status">
                    <span className="sr-only">Loading...</span>
                  </div>
                </div>
              ) : userDetails ? (
                <div className="row">
                  {/* User Information */}
                  <div className="col-md-4">
                    <div className="card">
                      <div className="card-header">
                        <h6 className="mb-0">User Information</h6>
                      </div>
                      <div className="card-body">
                        <p><strong>Mobile:</strong> {userDetails.user?.mobile}</p>
                        <p><strong>Email:</strong> {userDetails.user?.email || 'N/A'}</p>
                        <p><strong>Nickname:</strong> {userDetails.user?.nickName || 'N/A'}</p>
                        <p><strong>Device Type:</strong> {userDetails.user?.deviceType}</p>
                        <p><strong>Reward Points:</strong> {userDetails.user?.reward_points || 0}</p>
                        <p><strong>Created:</strong> {formatDate(userDetails.user?.createdAt)}</p>
                        <p><strong>Last Login:</strong> {formatDate(userDetails.user?.lastloginAt)}</p>
                        <p><strong>Last Activity:</strong> {formatDate(userDetails.user?.lastActivityAt)}</p>
                      </div>
                    </div>
                  </div>


                  {/* Level Rewards */}
                  <div className="col-md-4">
                    <div className="card">
                      <div className="card-header">
                        <h6 className="mb-0">Level Rewards</h6>
                      </div>
                      <div className="card-body">
                        {/* Eligible for New Rewards */}
                        {userDetails.eligibleForRewards && userDetails.eligibleForRewards.length > 0 && (
                          <div className="mb-4">
                            <h6 className="text-success">Eligible for Rewards:</h6>
                            {userDetails.eligibleForRewards.map((level, index) => (
                              <div key={index} className="mb-2 p-2 border border-success rounded">
                                <p className="mb-1"><strong>{level.level_name}</strong></p>
                                <p className="mb-2 small text-muted">Completed {level.hunt_count} treasures</p>
                                <button
                                  className="btn btn-sm btn-success"
                                  onClick={() => {
                                    setSelectedLevelForReward(level);
                                    setSendRewardFormData({
                                      reward_amount: '',
                                      transaction_id: '',
                                      notes: ''
                                    });
                                    setShowSendRewardModal(true);
                                  }}
                                >
                                  Send Reward
                                </button>
                              </div>
                            ))}
                          </div>
                        )}

                        {/* Already Earned Rewards */}
                        {/* {userDetails.user?.level_rewards && userDetails.user.level_rewards.length > 0 && (
                          <div>
                            <h6 className="text-info">Rewards Earned:</h6>
                            {userDetails.user.level_rewards.map((reward, index) => (
                              <div key={index} className="mb-3 p-2 border rounded">
                                <p><strong>Level:</strong> {reward.levelName}</p>
                                <p><strong>Amount:</strong> ₹{reward.reward_amount}</p>
                                <p><strong>Status:</strong>
                                  <span className={`badge ${reward.reward_status === 'sent' ? 'badge-success' :
                                    reward.reward_status === 'failed' ? 'badge-danger' : 'badge-warning'
                                    }`}>
                                    {reward.reward_status}
                                  </span>
                                </p>
                                {reward.transaction_id && (
                                  <p><strong>Transaction ID:</strong> {reward.transaction_id}</p>
                                )}
                                {reward.reward_sent_at && (
                                  <p><strong>Sent At:</strong> {formatDate(reward.reward_sent_at)}</p>
                                )}
                                <button
                                  className="btn btn-sm btn-primary"
                                  onClick={() => {
                                    setSelectedLevelReward(reward);
                                    setRewardFormData({
                                      reward_amount: reward.reward_amount,
                                      transaction_id: reward.transaction_id || '',
                                      notes: reward.notes || ''
                                    });
                                    setShowRewardForm(true);
                                  }}
                                >
                                  Update Reward
                                </button>
                              </div>
                            ))}
                          </div>
                        )} */}

                        {!userDetails.eligibleForRewards?.length && !userDetails.user?.level_rewards?.length && (
                          <p>No rewards available</p>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="card">
                      <div className="card-header">
                        <h6 className="mb-0">Level Rewards</h6>
                      </div>
                      <div className="card-body">
              

                        {/* Already Earned Rewards */}
                        {userDetails.user?.level_rewards && userDetails.user.level_rewards.length > 0 && (
                          <div>
                            <h6 className="text-info">Rewards Earned:</h6>
                            {userDetails.user.level_rewards.map((reward, index) => (
                              <div key={index} className="mb-3 p-2 border rounded">
                                <p><strong>Level:</strong> {reward.levelName}</p>
                                <p><strong>Amount:</strong> ₹{reward.reward_amount}</p>
                                <p><strong>Status:</strong>
                                  <span className={`badge ${reward.reward_status === 'sent' ? 'badge-success' :
                                    reward.reward_status === 'failed' ? 'badge-danger' : 'badge-warning'
                                    }`}>
                                    {reward.reward_status}
                                  </span>
                                </p>
                                {reward.transaction_id && (
                                  <p><strong>Transaction ID:</strong> {reward.transaction_id}</p>
                                )}
                                {reward.reward_sent_at && (
                                  <p><strong>Sent At:</strong> {formatDate(reward.reward_sent_at)}</p>
                                )}
                                <button
                                  className="btn btn-sm btn-primary"
                                  onClick={() => {
                                    setSelectedLevelReward(reward);
                                    setRewardFormData({
                                      reward_amount: reward.reward_amount,
                                      transaction_id: reward.transaction_id || '',
                                      notes: reward.notes || ''
                                    });
                                    setShowRewardForm(true);
                                  }}
                                >
                                  Update Reward
                                </button>
                              </div>
                            ))}
                          </div>
                        )}

                        {!userDetails.eligibleForRewards?.length && !userDetails.user?.level_rewards?.length && (
                          <p>No rewards available</p>
                        )}
                      </div>
                    </div>
                  </div>

                  {/* Treasure History */}
                  <div className="col-md-12 mt-3">
                    <div className="card">
                      <div className="card-header">
                        <h6 className="mb-0">Level History & Treasure Details</h6>
                      </div>
                      <div className="card-body">
                        {userDetails.levelHistory && userDetails.levelHistory.length > 0 ? (
                          <div className="accordion" id="levelAccordion">
                            {userDetails.levelHistory.map((level, levelIndex) => (
                              <div key={levelIndex} className="card">
                                <div className="card-header" id={`heading${levelIndex}`}>
                                  <h2 className="mb-0">
                                    <button
                                      className="btn btn-link collapsed"
                                      type="button"
                                      data-toggle="collapse"
                                      data-target={`#collapse${levelIndex}`}
                                      aria-expanded="false"
                                      aria-controls={`collapse${levelIndex}`}
                                    >
                                      {level.level_name} - {level.treasures?.length || 0} Treasures
                                    </button>
                                  </h2>
                                </div>
                                <div
                                  id={`collapse${levelIndex}`}
                                  className="collapse"
                                  aria-labelledby={`heading${levelIndex}`}
                                  data-parent="#levelAccordion"
                                >
                                  <div className="card-body">
                                    {level.treasures && level.treasures.length > 0 ? (
                                      <div className="row">
                                        {level.treasures.map((treasure, treasureIndex) => {
                                          const isHunted = treasure.viewed_users?.includes(selectedUser?.userId);
                                          const isOpened = treasure.opened_users?.includes(selectedUser?.userId);
                                          const isActive = isTreasureActive(treasure.expiredAt);

                                          // Only show if treasure is active OR user has hunted it
                                          if (!isActive && !isHunted) {
                                            return null;
                                          }

                                          return (
                                            <div key={treasureIndex} className="col-md-6 mb-3">
                                              <div className={`card ${!isActive ? 'border-secondary' : isHunted ? 'border-success' : 'border-warning'}`}>
                                                <div className="card-body">
                                                  <h6 className="card-title">{treasure.treasure_place}</h6>
                                                  <p className="card-text">{treasure.text}</p>

                                                  <div className="mb-2">
                                                    <span className={`badge ${isActive ? 'badge-success' : 'badge-secondary'} mr-2`}>
                                                      {isActive ? 'Active' : 'Expired'}
                                                    </span>
                                                    <span className={`badge ${isHunted ? 'badge-success' : 'badge-light'} mr-2`}>
                                                      {isHunted ? 'Hunted' : 'Not Hunted'}
                                                    </span>
                                                    <span className={`badge ${isOpened ? 'badge-info' : 'badge-light'}`}>
                                                      {isOpened ? 'Opened' : 'Not Opened'}
                                                    </span>
                                                  </div>

                                                  {treasure.quiz_enabled && treasure.userAnswer && (
                                                    <div className="mt-2">
                                                      <p><strong>Quiz Answer:</strong></p>
                                                      <span className={`badge ${treasure.userAnswer.is_correct ? 'badge-success' : 'badge-danger'}`}>
                                                        {treasure.userAnswer.is_correct ? 'Correct' : 'Wrong'}
                                                      </span>
                                                      <p><small>Answered: {formatDate(treasure.userAnswer.answered_at)}</small></p>
                                                    </div>
                                                  )}

                                                  <p><small className="text-muted">
                                                    Created: {formatDate(treasure.createdAt)}
                                                  </small></p>

                                                  {treasure.expiredAt && (
                                                    <p><small className="text-muted">
                                                      Expires: {formatDate(treasure.expiredAt)}
                                                    </small></p>
                                                  )}

                                                  <a
                                                    href={`https://www.google.com/maps?q=${treasure.latitude},${treasure.longitude}`}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="btn btn-sm btn-outline-primary"
                                                  >
                                                    View Location
                                                  </a>
                                                </div>
                                              </div>
                                            </div>
                                          );
                                        })}
                                      </div>
                                    ) : (
                                      <p>No treasures found for this level</p>
                                    )}
                                  </div>
                                </div>
                              </div>
                            ))}
                          </div>
                        ) : (
                          <p>No level history available</p>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <p>No user details available</p>
              )}
            </div>
          </div>
        </div>
      </div>

       {showSendRewardModal && (
        <div className="modal fade show" style={{ display: 'block' }} data-backdrop="static">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  Send Level Reward - {selectedLevelForReward?.level_name}
                </h5>
                <button
                  type="button"
                  className="close"
                  onClick={() => {
                    setShowSendRewardModal(false);
                    setSendRewardFormData({ reward_amount: '', transaction_id: '', notes: '' });
                  }}
                  aria-label="Close"
                >
                  <i className="fa-solid fa-xmark" />
                </button>
              </div>
              <form onSubmit={handleSendLevelReward}>
                <div className="modal-body">
                  <div className="alert alert-info">
                    <small>
                      User has completed <strong>{selectedLevelForReward?.hunt_count}</strong> treasures 
                      for level <strong>{selectedLevelForReward?.level_name}</strong>
                    </small>
                  </div>
                  <div className="form-group">
                    <label htmlFor="send_reward_amount">Reward Amount *</label>
                    <input
                      type="number"
                      className="form-control"
                      id="send_reward_amount"
                      placeholder="Enter reward amount"
                      value={sendRewardFormData.reward_amount}
                      onChange={(e) => setSendRewardFormData({ 
                        ...sendRewardFormData, 
                        reward_amount: e.target.value 
                      })}
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="send_transaction_id">Transaction ID *</label>
                    <input
                      type="text"
                      className="form-control"
                      id="send_transaction_id"
                      placeholder="Enter transaction ID"
                      value={sendRewardFormData.transaction_id}
                      onChange={(e) => setSendRewardFormData({ 
                        ...sendRewardFormData, 
                        transaction_id: e.target.value 
                      })}
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="send_notes">Notes</label>
                    <textarea
                      className="form-control"
                      id="send_notes"
                      rows="3"
                      placeholder="Optional notes"
                      value={sendRewardFormData.notes}
                      onChange={(e) => setSendRewardFormData({ 
                        ...sendRewardFormData, 
                        notes: e.target.value 
                      })}
                    />
                  </div>
                </div>
                <div className="modal-footer">
                  <button type="submit" className="btn btn-success">
                    Send Reward
                  </button>
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={() => {
                      setShowSendRewardModal(false);
                      setSendRewardFormData({ reward_amount: '', transaction_id: '', notes: '' });
                    }}
                  >
                    Cancel
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}

      {/* Reward Form Modal */}
      {showRewardForm && (
        <div className="modal fade show" style={{ display: 'block' }} data-backdrop="static">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Update Level Reward</h5>
                <button
                  type="button"
                  className="close"
                  onClick={() => {
                    setShowRewardForm(false);
                    setRewardFormData({ reward_amount: '', transaction_id: '', notes: '' });
                  }}
                  aria-label="Close"
                >
                  <i className="fa-solid fa-xmark" />
                </button>
              </div>
              <form onSubmit={handleRewardFormSubmit}>
                <div className="modal-body">
                  <div className="form-group">
                    <label htmlFor="reward_amount">Reward Amount *</label>
                    <input
                      type="number"
                      className="form-control"
                      id="reward_amount"
                      value={rewardFormData.reward_amount}
                      onChange={(e) => setRewardFormData({ ...rewardFormData, reward_amount: e.target.value })}
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="transaction_id">Transaction ID *</label>
                    <input
                      type="text"
                      className="form-control"
                      id="transaction_id"
                      value={rewardFormData.transaction_id}
                      onChange={(e) => setRewardFormData({ ...rewardFormData, transaction_id: e.target.value })}
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="notes">Notes</label>
                    <textarea
                      className="form-control"
                      id="notes"
                      rows="3"
                      value={rewardFormData.notes}
                      onChange={(e) => setRewardFormData({ ...rewardFormData, notes: e.target.value })}
                    />
                  </div>
                </div>
                <div className="modal-footer">
                  <button type="submit" className="btn btn-primary">
                    Update Reward
                  </button>
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={() => {
                      setShowRewardForm(false);
                      setRewardFormData({ reward_amount: '', transaction_id: '', notes: '' });
                    }}
                  >
                    Cancel
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default UserList;
